import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import Metrics from 'metrics';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { CompanyProvider } from 'contexts/CompanyContext';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
    return (
        <>
            <ThemeCustomization>
                <RTLLayout>
                    <Locales>
                        <ScrollTop>
                            <AuthProvider>
                                <CompanyProvider>
                                    <Notistack>
                                        <RouterProvider router={router} />
                                        <Snackbar />
                                    </Notistack>
                                </CompanyProvider>
                            </AuthProvider>
                        </ScrollTop>
                    </Locales>
                </RTLLayout>
            </ThemeCustomization>
            <Metrics />
        </>
    );
}